<template>
    <div class="uploadStyle">
        <div
            class="every"
            v-for="(item, index) in uplodData"
            :key="index"
            @click="handleGetItem(item)"
        >
            <!-- pdf -->
            <span
                class=" iconfont ys-iconpdf allIcon"
                v-if="
                    item.split('.')[item.split('.').length - 1] === 'pdf' ||
                        item.split('.')[item.split('.').length - 1] === 'PDF'
                "
                :style="uploadStyle ? 'color:rgb(52, 133, 251);cursor: pointer;' : ''"
            ></span>
            <!-- word -->
            <span
                class="iconfont ys-iconword allIcon"
                v-if="
                    item.split('.')[item.split('.').length - 1] === 'doc' ||
                        item.split('.')[item.split('.').length - 1] === 'docx' ||
                        item.split('.')[item.split('.').length - 1] === 'DOC' ||
                        item.split('.')[item.split('.').length - 1] === 'DOCX'
                "
                :style="uploadStyle ? 'color:rgb(52, 133, 251);cursor: pointer;' : ''"
            ></span>
            <!-- excle -->
            <span
                class="iconfont ys-iconexcel allIcon"
                v-if="
                    item.split('.')[item.split('.').length - 1] === 'xls' ||
                        item.split('.')[item.split('.').length - 1] === 'xlsx' ||
                        item.split('.')[item.split('.').length - 1] === 'XLS' ||
                        item.split('.')[item.split('.').length - 1] === 'XLSX'
                "
                :style="uploadStyle ? 'color:rgb(52, 133, 251);cursor: pointer;' : ''"
            ></span>
            <!-- 图片 -->
            <span
                class="iconfont ys-icontupian allIcon"
                v-if="
                    item.split('.')[item.split('.').length - 1] === 'jpg' ||
                        item.split('.')[item.split('.').length - 1] === 'jpeg' ||
                        item.split('.')[item.split('.').length - 1] === 'png' ||
                        item.split('.')[item.split('.').length - 1] === 'gif' ||
                        item.split('.')[item.split('.').length - 1] === 'JPG' ||
                        item.split('.')[item.split('.').length - 1] === 'JPEG' ||
                        item.split('.')[item.split('.').length - 1] === 'PNG' ||
                        item.split('.')[item.split('.').length - 1] === 'GIF'
                "
                :style="uploadStyle ? 'color:rgb(52, 133, 251);cursor: pointer;' : ''"
            ></span>
            <!-- zip压缩文件 -->
            <span
                class="iconfont ys-iconzip allIcon"
                v-if="
                    item.split('.')[item.split('.').length - 1] === 'zip' ||
                        item.split('.')[item.split('.').length - 1] === 'ZIP'
                "
                :style="uploadStyle ? 'color:rgb(52, 133, 251);cursor: pointer;' : ''"
            ></span>
            <span :style="uploadStyle ? 'color:rgb(52, 133, 251);cursor: pointer;' : ''">
                {{ item }}
            </span>
            <span
                class="iconfont ys-iconshanchu"
                v-if="closeBtnStatus"
                @click.stop="hanleDelateClick(index)"
            ></span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        // 接受到的数组结构
        uplodData: {
            type: Object,
            // 必传
            required: true,
        },
        // 可选参数-控制关闭按钮是否展示
        closeBtnStatus: {
            type: Boolean,
            default: true,
        },
        // 悬浮样式
        uploadStyle: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        // 删除
        hanleDelateClick(index) {
            this.$emit('on-upload-delate', index);
        },
        // 点击列获取数据
        handleGetItem(item) {
            this.$emit('on-handle-item', item);
        },
    },
};
</script>
<style lang="less">
.uploadStyle {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .every {
        position: relative;
        width: 207px;
        height: 35px;
        line-height: 35px;
        background: rgba(216, 216, 216, 0.1);
        border-radius: 4px;
        margin-right: 16px;
        padding: 0px 10px;
        box-sizing: border-box;
        margin-bottom: 20px;
        .allIcon {
            margin-right: 10px;
            position: relative;
            top: -11px;
        }
        span:nth-of-type(2) {
            display: inline-block;
            width: 158px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(215, 227, 245, 1);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        span:nth-of-type(3) {
            position: absolute;
            top: -12px;
            right: -4px;
        }
        span:nth-of-type(3):hover {
            cursor: pointer;
        }
    }
}
</style>
